import { Injectable } from "@angular/core";
import { AngularFireStorage } from "@angular/fire/storage";
import { AngularFireFunctions } from "@angular/fire/functions";

@Injectable({
  providedIn: "root"
})
export class CloudService {
  private text;

  constructor(
    private storage: AngularFireStorage,
    private fns: AngularFireFunctions
  ) {}

  public imagePath: string;

  upload(file: File) {
    this.imagePath = this.uuidv4();
    const task = this.storage.upload(this.imagePath, file);
    return task;
  }

  async callExtractText(fileName: string) {
    const seconds: number = new Date().getTimezoneOffset();
    const callable = this.fns.httpsCallable("callExtractText");
    const response = await callable({
      fileName: fileName,
      timezoneOffset: seconds
    }).toPromise();
    this.text = response;
    window.open(response.result.google, "_blank");
    // console.log(response.parsed);
  }

  getText() {
    return this.text;
  }

  /**
   * Generates a unique identifyer
   * For an RFC4122 version 4 compliant solution
   */
  private uuidv4(): string {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
      var r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  //   /**
  //    * Retreives google calendar, icalendar, or outlook calendar
  //    */
  //   public getCalendarLink(title: string, start: Date, end: Date){
  //     var cal = require('generate-calendar-url');

  //     // title, start, and end are required
  //     var event = {
  //       title: title,
  //       start: start,
  //       end: end,
  //       // location: '123 Fake St',
  //       // description: 'Johnny is having a blowout'
  //     };

  //     console.log(cal.google(event));
  //     // https://www.google.com/calendar/render?action=TEMPLATE&text=BDay%20Bash&dates=20200721T020000Z%2F20200721T050000Z&details=Johnny%20is%20having%20a%20blowout&location=123%20Fake%20St

  //     // console.log(cal.ical(event));
  //     // // data:text/calendar;charset=utf8,BEGIN:VCALENDAR%0AVERSION:2.0%0ABEGIN:VEVENT%0ADTSTART:20200721T020000Z%0ADTEND:20200721T050000Z%0ASUMMARY:BDay%20Bash%0ADESCRIPTION:Johnny%20is%20having%20a%20blowout%0ALOCATION:123%20Fake%20St%0AEND:VEVENT%0AEND:VCALENDAR

  //     // console.log(cal.outlook(event));
  //     // // data:text/calendar;charset=utf8,BEGIN:VCALENDAR%0AVERSION:2.0%0ABEGIN:VEVENT%0ADTSTART:20200721T020000Z%0ADTEND:20200721T050000Z%0ASUMMARY:BDay%20Bash%0ADESCRIPTION:Johnny%20is%20having%20a%20blowout%0ALOCATION:123%20Fake%20St%0AEND:VEVENT%0AEND:VCALENDAR
  //     return cal.google(event);
  //   }
}
